import { CircleCheck, CircleX } from 'lucide-react';

export const OkStatusIndicator = () => {
  return <CircleCheck className="fill-green-500 stroke-white" />;
};

export const NotOkStatusIndicator = () => {
  return <CircleX className="fill-red-500 stroke-white" />;
};
